import { version } from './version.ts';

export { version };
